export default "__VITE_ASSET__3658cb0d__"